import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { lg } from '~/modules/colorLog';

import countryData from './allCountries.json';
import lcData from './localCountryName.json';

import { DefaultLangCode, DefaultLangId, LANGUAGES } from '~/constant/ui.constant';
import { uiHelper } from '~/helpers/ui.helper';
import { Title } from '@angular/platform-browser';

let LANGUAGE_DATA;
@Injectable()
export class translationHelper implements OnDestroy {
    public LANGID = 2;
    public LANGCODE = 'en';
    public LANGCODENABRR = 'en-US';
    public TIMEZONE = 0;
    public ISOABBR = 'gb';
    public lcData;
    private languageChannel: BroadcastChannel;

    public langDatas = {
        en: {
            langID: 2,
            langCode: 'en',
            langCodeNotAbrr: 'en-US',
            langNativeNames: '',
            ISOabbr: 'gb',
        },
        tr: {
            langID: 3,
            langCode: 'tr',
            langCodeNotAbrr: 'tr-TR',
            langNativeNames: '',
            ISOabbr: 'tr',
        },
        aa: {
            langID: 4,
            langCode: 'aa',
            langCodeNotAbrr: 'en',
            langNativeNames: '',
            ISOabbr: 'iq',
        },
        ru: {
            langID: 5,
            langCode: 'ru',
            langCodeNotAbrr: 'ru',
            langNativeNames: '',
            ISOabbr: 'ru',
        },
        de: {
            langID: 6,
            langCode: 'de',
            langCodeNotAbrr: 'de',
            langNativeNames: '',
            ISOabbr: 'de',
        },
        es: {
            langID: 7,
            langCode: 'es',
            langCodeNotAbrr: 'en',
            langNativeNames: '',
            ISOabbr: 'es',
        },
        fa: {
            langID: 8,
            langCode: 'fa',
            langCodeNotAbrr: 'en',
            langNativeNames: '',
            ISOabbr: 'fa',
        },
        ku: {
            langID: 10,
            langCode: 'ku',
            langCodeNotAbrr: 'en',
            langNativeNames: '',
            ISOabbr: 'gb',
        },
        pl: {
            langID: 12,
            langCode: 'pl',
            langCodeNotAbrr: 'pl',
            langNativeNames: '',
            ISOabbr: 'pl',
        },
        fr: {
            langID: 14,
            langCode: 'fr',
            langCodeNotAbrr: 'fr',
            langNativeNames: '',
            ISOabbr: 'fr',
        },
        el: {
            langID: 15,
            langCode: 'el',
            langCodeNotAbrr: 'el',
            langNativeNames: '',
            ISOabbr: 'el',
        },
        bg: {
            langID: 17,
            langCode: 'bg',
            langCodeNotAbrr: 'bg',
            langNativeNames: '',
            ISOabbr: 'bg',
        },
        da: {
            langID: 19,
            langCode: 'da',
            langCodeNotAbrr: 'da',
            langNativeNames: '',
            ISOabbr: 'da',
        },
        ro: {
            langID: 20,
            langCode: 'ro',
            langCodeNotAbrr: 'ro-RO',
            langNativeNames: '',
            ISOabbr: 'ro',
        },
        it: {
            langID: 22,
            langCode: 'it',
            langCodeNotAbrr: 'it-IT',
            langNativeNames: '',
            ISOabbr: 'it',
        },
        pt: {
            langID: 11,
            langCode: 'pt',
            langCodeNotAbrr: 'pt-PT',
            langNativeNames: '',
            ISOabbr: 'pt',
        },
        sq: {
            langID: 16,
            langCode: 'sq',
            langCodeNotAbrr: 'sq',
            langNativeNames: '',
            ISOabbr: 'sq',
        },
    } as object;
    public tempLangDatas = {};
    public supportedLangs = LANGUAGES;

    DATA_INITIALIZER;

    public languageUpdate: EventEmitter<any> = new EventEmitter();

    constructor(private _UiHelper: uiHelper, private titleService: Title) {
        // Initialize broadcast channel for language changes
        this.languageChannel = new BroadcastChannel('language_change_channel');

        // Listen for language changes from other tabs
        this.languageChannel.onmessage = event => {
            if (event.data && event.data.type === 'language_changed') {
                // Update language without broadcasting to avoid loops
                this.updateLanguage(event.data.language);
            }
        };

        this.DATA_INITIALIZER = data =>
            new Promise<void>(done => {
                //lg('INIT', 'TRANSLATE OKAY..');
                try {
                    LANGUAGE_DATA = JSON.parse(data);
                    done();
                } catch (e) {
                    this._UiHelper.SendElectronMessage('electronListener', {
                        type: 'internetconnection',
                        status: false,
                        tid: this.titleService.getTitle(),
                    });
                    console.error(e);
                }
            });

        this.supportedLangs.forEach(y => {
            Object.keys(this.langDatas).forEach(key => {
                this.langDatas[key].langNativeNames = lcData[this.langDatas[key].langCode].nativeName;

                if (key == y) {
                    this.tempLangDatas[y] = this.langDatas[y];
                    // console.log(this.tempLangDatas);
                }
            });
        });

        this.langDatas = this.tempLangDatas;

        this.lcData = countryData;

        //  this.langDatas[this.LANGCODE].langNativeNames = lcData[this.LANGCODE].nativeName;

        this.init();
        // this.LANGCODE = navigator.language.substr(0, 2);
    }

    public ngOnDestroy() {
        // Close the channel when service is destroyed
        if (this.languageChannel) {
            this.languageChannel.close();
        }
    }

    public init() {
        //  According to client time setting.
        const d = new Date();
        this.TIMEZONE = d.getTimezoneOffset();

        if (localStorage.getItem('langcode') == undefined) {
            const langcodeNavigator = navigator.language.substr(0, 2);
            if (this.supportedLangs.includes(langcodeNavigator)) {
                // console.log(this.LANGID);

                this.LANGCODE = langcodeNavigator;
                this.LANGID = this.langDatas[langcodeNavigator].langID;
                this.LANGCODENABRR = this.langDatas[langcodeNavigator]['langCodeNotAbrr'];
                this.ISOABBR = this.langDatas[langcodeNavigator]['ISOabbr'];
                localStorage.setItem('langcode', langcodeNavigator);
            } else {
                this.LANGID = DefaultLangId;
                this.LANGCODE = DefaultLangCode;
                this.LANGCODENABRR = this.langDatas[this.LANGCODE]['langCodeNotAbrr'];
                this.ISOABBR = this.langDatas[this.LANGCODE]['ISOabbr'];
                localStorage.setItem('langcode', DefaultLangCode);
            }
        } else {
            this.LANGCODE = localStorage.getItem('langcode');
            this.LANGID = this.langDatas[localStorage.getItem('langcode')].langID;
            this.LANGCODENABRR = this.langDatas[localStorage.getItem('langcode')]['langCodeNotAbrr'];
            this.ISOABBR = this.langDatas[localStorage.getItem('langcode')]['ISOabbr'];
        }
    }

    public changeLang(v: string) {
        // Update language locally
        this.updateLanguage(v);

        // Broadcast language change to all tabs
        this.languageChannel.postMessage({
            type: 'language_changed',
            language: v,
            languageId: this.LANGID,
        });
    }

    // Private method to update language without broadcasting
    private updateLanguage(v: string) {
        this.LANGCODE = v;
        this.LANGID = this.langDatas[v].langID;
        console.log(v);
        localStorage.setItem('langcode', v);
        this.init();
        this._UiHelper.setRefreshApp();
    }

    public getT(value) {
        if (LANGUAGE_DATA[value] == undefined) {
            console.log('Not found : ', value);
            return '';
        }
        return LANGUAGE_DATA[value][this.LANGCODE];
    }

    public transformTranslate(str: string) {
        return str.replace(/\{((\s*?.*?)*?)\}/g, (x, y) => {
            return this.getT(y);
        });
    }
}

@Pipe({ name: 't' })
export class translatePipe implements PipeTransform {
    public CURRENT_LANG = 'de';

    constructor() {
        if (localStorage.getItem('langcode')) {
            this.CURRENT_LANG = localStorage.getItem('langcode');
        } else {
            localStorage.setItem('langcode', this.CURRENT_LANG);
        }
    }

    public transform(value: string): string {
        if (LANGUAGE_DATA[value] == undefined) {
            console.log('Not found : ', value);
            return '';
        }
        return LANGUAGE_DATA[value][this.CURRENT_LANG];
    }
}
